import { render } from "./Reporting.vue?vue&type=template&id=b98ae006&ts=true"
import script from "./Reporting.vue?vue&type=script&lang=ts"
export * from "./Reporting.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__